import { Box, Input, Typography } from "@mui/material";

export function LabelValueInput<D extends number | string>({
  label,
  value,
  type = "text",
  onChange,
}: {
  label: string;
  value: D;
  type: "text" | "number";
  onChange: (newValue: D) => void;
}) {
  return (
    <Box>
      <Typography>{label}</Typography>
      <Input
        type={type}
        value={value}
        onChange={(e) =>
          onChange(
            type === "number"
              ? (parseFloat(e.target.value) as D)
              : (e.target.value as D)
          )
        }
      />
    </Box>
  );
}
